import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function Faq({ items, testId = "faq" }) {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <div data-testid={testId} className="space-y-3">
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        return (
          <div key={i} className="rounded-2xl bg-surface border border-line overflow-hidden">
            <button
              type="button"
              onClick={() => setOpenIdx(isOpen ? null : i)}
              data-testid={`${testId}-q-${i}`}
              className="w-full flex items-center justify-between gap-4 text-left p-5 md:p-6"
            >
              <span className="font-display font-semibold text-lg md:text-xl">{item.q}</span>
              <span className={`shrink-0 w-8 h-8 rounded-full bg-stone flex items-center justify-center text-emerald transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}>
                <Plus size={16} />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-5 md:px-6 pb-5 md:pb-6 text-graphite leading-relaxed text-[15px] max-w-2xl">{item.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
